import { render, staticRenderFns } from "./KurccFormMultiChoiceAdditionalButtonsPhotoComment.vue?vue&type=template&id=b094d574&"
import script from "./KurccFormMultiChoiceAdditionalButtonsPhotoComment.vue?vue&type=script&lang=js&"
export * from "./KurccFormMultiChoiceAdditionalButtonsPhotoComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports